import { Injectable, Type } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { Toast } from './toast.class';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastSubject = new ReplaySubject<Toast>(1);
  public toasts: Observable<Toast> = this.toastSubject.asObservable();

  public add(
    message: string,
    isGood = true,
    duration = 3000,
    component: { comp: Type<unknown>; inputs: { [key: string]: unknown } } = null,
    hideIcon = false
  ) {
    this.toastSubject.next(new Toast(message, duration, isGood, component, hideIcon));
  }
}
